import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ClientNav from './ClientNav'
import CallNav from './CallNav'
import TicketNav from './TicketNav'
import KnowledgeNav from './KnowledgeNav'
import SettingNav from './SettingsNav'
import AgentNav from './AgentNav'
import InvitationNav from './InvitationNav'
import IntegrationNav from './IntegrationsNav'
import SmsNav from './SmsNav'
import EmailNav from './EmailNav'
import CrmNav from './CrmNav'
import WhatsappNav from './WhatsappNav'
import ReportsNav from './ReportsNav'
import CampaignsNav from './CampaignsNav'
import UserNav from './UserNav'

export default function FeaturesRoutes() {
    return (
        <Routes>
            <Route path="/clients/*" element={<ClientNav />} />
            <Route path="/calls/*" element={<CallNav />} />
            <Route path="/tickets/*" element={<TicketNav />} />
            <Route path="/knowledge/*" element={<KnowledgeNav />} />
            <Route path="/settings/*" element={<SettingNav />} />
            <Route path="/agents/*" element={<AgentNav />} />
            <Route path="/invitations/*" element={<InvitationNav />} />
            <Route path="/integrations/*" element={<IntegrationNav />} />
                    <Route path="/users/*" element={<UserNav />} />


             <Route path="/sms/*" element={<SmsNav />} />
            <Route path="/email/*" element={<EmailNav />} />
            <Route path="/crm/*" element={<CrmNav />} />
            <Route path="/whatsapp/*" element={<WhatsappNav />} />
            <Route path="/reports/*" element={<ReportsNav />} />
            <Route path="/campaigns/*" element={<CampaignsNav />} />
          

        </Routes>
    )
}
